<template>
  <div id="manageUser">
    <v-toolbar color="rgb(250,250,250)" dense>
      <v-toolbar-items>
        <v-btn color="primary" text @click.native="close">{{
          lang.back
        }}</v-btn>
      </v-toolbar-items>
      <v-divider vertical />
      <v-toolbar-title class="ml-2" color="primary">{{
        email
      }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn text @click="disable" v-if="user.status" color="secondary">{{
          lang.disable
        }}</v-btn>
        <v-btn
          text
          @click="enable"
          v-else-if="user.status === false"
          color="red"
          >{{ lang.activate }}</v-btn
        >
        <v-btn
          :disabled="loading"
          @click="add_coupon = true"
          text
          color="primary"
          >{{ lang.assign_coupon }}</v-btn
        >
        <v-btn
          v-if="user.canAddTrial"
          @click="openDialog()"
          :disabled="
            (user.billing_account_subs &&
              user.billing_account_subs.trial_added == 'true') ||
              false
          "
          text
          color="primary"
          >{{ lang.add_trial }}</v-btn
        >
        <!--  <v-btn text color="primary">Extend Storage</v-btn>
        <v-btn text color="primary">Invoices</v-btn>
         <v-btn text color="primary" v-if="checkHasCard()" @click="cardDetails=true">{{lang.card_details}}</v-btn>
        <v-btn text color="error">Delete</v-btn>-->
      </v-toolbar-items>
    </v-toolbar>
    <v-progress-linear
      v-if="pageLoading"
      class="mt-1"
      indeterminate
    ></v-progress-linear>
    <v-layout
      :class="{
        'mx-0 mt-1': $vuetify.breakpoint.xs,
        'mx-2 mt-1': $vuetify.breakpoint.smAndUp,
      }"
      row
      wrap
    >
      <v-flex md3 class="mt-2">
        <subscriptions :user="user" :loading="pageLoading"></subscriptions>
      </v-flex>
      <v-divider vertical></v-divider>
      <v-flex md8>
        <v-card flat class="mt-2">
          <v-layout column pa-1 wrap>
            <v-flex mb-1>
              <userDetails
                :players="players"
                :user="user"
                :email="email"
                :subUsers="subUsers"
              />
            </v-flex>

            <v-flex mb-1>
              <userPlayers :players="players" :user="user" />
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="cardDetails" width="600px" v-if="checkHasCard()">
      <v-card>
        <v-card-title>{{ lang.card_details }}</v-card-title>
        <v-divider class="ma-0"></v-divider>
        <v-container grid-list-sm class="pa-4">
          <v-layout row wrap>
            <v-flex md12 pa-2>
              <span class="heading-2 font-weight-bold">{{ lang.brand }}</span>
              {{ user.billing_account_subs.card.brand }}
            </v-flex>
            <v-flex md12 pa-2>
              <span class="heading-2 font-weight-bold">{{
                lang.name_on_card
              }}</span>
              {{ user.billing_account_subs.card.name }}
            </v-flex>
            <v-flex md12 pa-2>
              <span class="heading-2 font-weight-bold">{{ lang.funding }}</span>
              {{ user.billing_account_subs.card.funding }}
            </v-flex>
            <v-flex md12 pa-2>
              <span class="heading-2 font-weight-bold">{{
                lang.card_number
              }}</span>
              **** **** **** {{ user.billing_account_subs.card.card_last4 }}
            </v-flex>
            <v-flex md12 pa-2>
              <span class="heading-2 font-weight-bold">{{ lang.expiry }}</span>
              {{ user.billing_account_subs.card.expMonth }}/{{
                user.billing_account_subs.card.expYear
              }}
            </v-flex>
          </v-layout>
        </v-container>
        <v-divider class="ma-0"></v-divider>
        <v-card-actions>
          <v-btn text color="primary" @click="cardDetails = false">{{
            lang.close
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <addCouponDialog
      @update="init"
      :user="user"
      @close="add_coupon = false"
      :dialog="add_coupon"
    />
    <dialogConfirm
      :dialog="trialConfirm"
      :title="lang.confirm_add_trial"
      :msg="lang.confirmTrialMessage"
      @onConfirm="addtrial()"
      @onCancel="cancelAddtrial()"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import userDetails from "./user_details.vue";
import userPlayers from "./user_players.vue";
import subscriptions from "./subscriptions.vue";
import addCouponDialog from "./add_coupon.vue";
import dialogConfirm from "@/components/dialogConfirm";
const manage = require("./manage.js").manage;
export default {
  components: {
    userDetails,
    userPlayers,
    subscriptions,
    addCouponDialog,
    dialogConfirm,
  },
  data() {
    return {
      pageLoading: true,
      user: {},
      add_coupon: false,
      add_trial: false,
      search: "",
      players: [],
      subUsers: [],
      cardDetails: false,
      trialConfirm: false,
    };
  },
  props: {
    email: {
      default: "",
    },
  },
  computed: {
    ...mapState(["loading", "fb", "adminUser", "lang", "page_name"]),
  },
  methods: {
    enable() {
      manage.changeStatus(this.email, "activate");
    },
    disable() {
      manage.changeStatus(this.email, "disable");
    },
    close() {
      this.$emit("dialog", false);

      // this.$router.push({ path: "/playlists/" + this.type });
    },
    init() {
      manage.init(this);
    },
    checkHasCard() {
      if (
        this.user.billing_account_subs != null &&
        this.user.billing_account_subs.card != null
      ) {
        return true;
      } else {
        return false;
      }
    },
    openDialog() {
      this.trialConfirm = true;
    },
    addtrial() {
      this.pageLoading = true;
      manage.addTrial(this.email);
      this.trialConfirm = false;
    },
    cancelAddtrial() {
      this.trialConfirm = false;
    },
  },
  destroyed() {
    manage.destroy();
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="sass" scoped></style>
